import React, { useState, useEffect } from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import TextVariables from '../../../../classes/TextVariables';


export default function Checkbox(props)
{
	const style = {
		pointerEvents: props.pointerEvents ? props.pointerEvents : "none",
	}

	const simulationState = useSelector(state => state.applicationModule.simulationState, shallowEqual);

	const [value, setValue] = useState(false);

	useEffect(() =>
	{
		generateInitialValue();
	}, [props.prefill]); 

	function generateInitialValue()
	{
		if(!props.prefill) return false;

		if(props.prefill.startsWith('#'))
		{
			const prefillData = TextVariables.textToData(props.prefill);
			if(isNaN(prefillData)) return false;
			setValue( Number(prefillData));
			return;
		}

		if(isNaN(props.prefill))
		{
			if(props.prefill === 'true')
			{
				setValue(true);
			}
			else
			{
				setValue(false);
			}
			return;
		}

		setValue(Number(props.prefill));
	}

	

	//render
	return (
		<input type="checkbox" className={'checklistPreviewCheckbox'} style={style} checked={value} onChange={(e)=>
		{
			setValue(e.target.checked);
			if(props.onChangeCallback)
			{
				props.onChangeCallback(e.target.checked);
			}
		}}/>
	)
}